import { TEXT_PRESETS } from '../../../../../../../../../../components/global/CardDesigner/components/CardDesignerCardElements/CardDesignerCardElementText/helpers';
import {
  getIdentityFullName,
  getIdentityLastName,
  getIdentityName,
} from '../../../../../../../../../../util/identity';

/**
 * Gets PrintProductConfiguration for PrintProduct CustomPrint checkout.
 *
 * @param {Object} card The card.
 * @returns {undefined|{print_product_id, print_product_size_id}}
 */
export const getCardPrintProductConfiguration = card => {
  if (!card) {
    return undefined;
  }

  const cardTemplate =
    card.card_side_groups.records[0].card_sides.records[0].card_template;
  const printProduct = cardTemplate.print_product;
  const sizes = printProduct?.sizes?.records ?? [];
  const printSize = cardTemplate.print_size;
  const printProductSize = printSize
    ? sizes.find(productSize => productSize.print_size?.id === printSize.id) ??
      sizes?.[0]
    : sizes?.[0];

  if (!printProduct) {
    return undefined;
  }

  return {
    print_product_id: printProduct.id,
    print_product_size_id: printProductSize.id,
  };
};

/**
 * Gets Target Account Card required data for a given card
 *
 * @param {Object} card The card.
 * @returns {{ printSize, orientation }}
 */
export const getCardTargetAccountCardConfiguration = card => {
  if (!card) {
    return undefined;
  }

  const cardTemplate =
    card.card_side_groups.records[0].card_sides.records[0].card_template;
  const printSize = cardTemplate.print_size;

  return {
    printSize,
    orientation: cardTemplate?.orientation,
  };
};

/**
 * Given a preset label, determine the contents of the text element
 *
 * @param {Object} data
 * @param {String} data.presetLabel the preset label, off of TEXT_PRESETS
 * @param {Object} data.identity the active identity
 * @param {Object} data.albumMembershipGroup the album membership group
 * @param {String} data.teamName the identity's team name
 * @param {String} data.levelName the identity's level name
 * @returns {String}
 */
export const getTextElementPresetData = ({
  presetLabel,
  identity,
  albumMembershipGroup,
  teamName,
  levelName,
}) => {
  switch (presetLabel) {
    case TEXT_PRESETS.GALLERY_NAME_INSERT:
      return (
        albumMembershipGroup?.album?.root_album_folder?.name ??
        albumMembershipGroup?.album_folder?.name ??
        ''
      );
    case TEXT_PRESETS.ALBUM_NAME_INSERT:
      return albumMembershipGroup?.album?.name ?? '';
    case TEXT_PRESETS.TEAM_LEVEL_INSERT:
      return levelName ?? '';
    case TEXT_PRESETS.TEAM_NAME_INSERT:
      return teamName ?? '';
    case TEXT_PRESETS.FULL_NAME_INSERT:
      return getIdentityFullName(identity) ?? '';
    case TEXT_PRESETS.FIRST_NAME_INSERT:
      return getIdentityName(identity) ?? '';
    case TEXT_PRESETS.LAST_NAME_INSERT:
      return getIdentityLastName(identity) ?? '';
    case TEXT_PRESETS.YEAR_INSERT:
      return `${new Date().getFullYear()}`;
    default:
      return '';
  }
};
